export default __webpack_public_path__ + "static/media/background.700fc1dc.jpg";